import { UntypedFormGroup, ValidatorFn } from '@angular/forms'
import { Matrix } from 'app/models/questions/Matrix'

export function requireSelectionOnEachMatrixRow(matrix: Matrix): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup) {
    let rowHasSelectedValue = false
    const statementKeys = Object.keys(formGroup.controls)

    for (const idx in statementKeys) {
      const control = formGroup.controls[statementKeys[idx]]

      if (!control.enabled) {
        continue
      }

      const values = control.get(matrix.formControlName).value

      for (const sKey in values) {
        if (values[sKey]) {
          rowHasSelectedValue = true
          break
        }
      }

      if (!rowHasSelectedValue) {
        return {
          requireSelectionOnEachMatrixRow: true
        }
      }

      rowHasSelectedValue = false
    }

    return null
  }
}
